import { ListItemButton, ListItemText, styled } from '@mui/material';
import { FC } from 'react';
import { Link, useMatch, useResolvedPath } from 'react-router-dom';
import { NavigationWidth } from './navigation.helpers';

export type NavigationSubitemProps = {
  label: string;
  to: string;
  state?: unknown;
};

const SubItemButton = styled(ListItemButton)(({ theme }) => ({
  backgroundColor: theme.palette.primary.light,
  width: NavigationWidth.Normal,
  color: theme.palette.primary[30],
  '&': {
    paddingLeft: '54px',
  },
  '&.NavigationSubitem-active': {
    color: theme.palette.common.white,
    backgroundColor: `${theme.palette.primary[80]}`,
    boxShadow: `inset 0px -1px 0px ${theme.palette.primary[80]}`,
  },
  '&:hover': {
    backgroundColor: `${theme.palette.primary.main}`,
  },
}));

export const NavigationSubitem: FC<NavigationSubitemProps> = ({ label, to, state }) => {
  const resolved = useResolvedPath(to);
  const match = useMatch({ path: resolved.pathname, end: false, caseSensitive: true });
  return (
    <Link to={to} state={state}>
      <SubItemButton data-cy={`navigationSubitem_${to}`} className={match ? 'NavigationSubitem-active' : ''}>
        <ListItemText primary={label} />
      </SubItemButton>
    </Link>
  );
};
